
import "./scss/style.scss";
import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'lightslider';
import 'lightgallery/src/js/lightgallery.js';
import 'lightgallery/modules/lg-thumbnail.js';
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n/de.js";
import "flatpickr/dist/l10n/it.js";
import "flatpickr/dist/l10n/hr.js";
import "flatpickr/dist/l10n/cs.js";
import "flatpickr/dist/l10n/hu.js";
import "flatpickr/dist/l10n/sk.js";
import "flatpickr/dist/l10n/sl.js";
import "flatpickr/dist/l10n/pl.js";
import functions from "./js/functions.js";
import "select2";
import lozad from 'lozad';
import "./js/globals.js";
import "./js/list.js";
import "./js/details.js";
import "./js/loadGmap.js";
import "./js/booking.js";
import "./js/contact.js";
import "./js/newsletter.js";


flatpickr.localize(flatpickr.l10ns[functions.getLang()]);
flatpickr.l10ns.default.firstDayOfWeek = 1;

window.lozadObserver = lozad('.lozad', {
    rootMargin: '200px 200px',
    loaded(el) {
        //const $slider = $(el).closest('.lSSlideOuter');
        //$slider.length && $.map($slider.find('.lozad'), lozadObserver.triggerLoad);
    }
});
lozadObserver.observe();

window.nobserver = lozad('.form-contact', {
    rootMargin: '200px 0px',
    loaded: el => {
        $.getScript("https://www.google.com/recaptcha/api.js?render=" + '6LeAz5gUAAAAAKoZP6-NVwB5wTFGjyeCVGmm582z');
    }
});
window.nobserver.observe();

window.nobserver = lozad('.load-recaptcha', {
    rootMargin: '200px 0px',
    loaded: el => {
        $.getScript("https://www.google.com/recaptcha/api.js?render=" + '6LeAz5gUAAAAAKoZP6-NVwB5wTFGjyeCVGmm582z');
    }
});
window.nobserver.observe();


